import deliverySetApi from "@/api/delivery/deliverySetApi";

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async addCarcase(_, { query }) {
      try {
        await deliverySetApi.addCarcase(query);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async addSummaryAddition(_, {query, form}) {
      try {
        await deliverySetApi.addSummaryAddition(query, form);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async changeSummaryAddition(_, {query, form}) {
      try {
        await deliverySetApi.changeSummaryAddition(query, form);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async calcCarcases(_, { query}) {
      try {
        const response = await deliverySetApi.calcCaracases(query);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async deleteCarcase(_, {carcaseId, deliverySetId}) {
      try {
        await deliverySetApi.deleteCaracases(carcaseId, deliverySetId);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async getTree({dispatch}, {force}) {
      try {
        const response = await deliverySetApi.getTree(force);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async getInfo({dispatch}, {deliveryId}) {
      try {
        const response = await deliverySetApi.getInfo(deliveryId);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async getOpenTransactions({dispatch}, {deliveryId}) {
      try {
        const response = await deliverySetApi.getOpenTransactions(deliveryId);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async setOpenTransactions({dispatch}, {deliveryId, data}) {
      try {
        await deliverySetApi.setOpenTransactions(deliveryId, data);
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async getCarcases({dispatch}, {query, forceReload}) {
      try {
        const response = await deliverySetApi.getCaracases(query, forceReload);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async merge({dispatch}, form) {
      try {
        const response = await deliverySetApi.merge(form);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async updateCarcase(_, {query, form}) {
      try {
        await deliverySetApi.updateCarcase(query, form);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async updatePrice(_, {query, form}) {
      try {
        await deliverySetApi.updatePrice(query, form);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async updateMasterdata({dispatch}) {
      try {
        await deliverySetApi.updateMasterdata();
        await dispatch('NOTIFY_MSG', 'delivery.notifications.updateMasterdata', {root: true});
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async changeSlaughterHouse(_, {query, form }) {
      try {
        const response = await deliverySetApi.changeSlaughterHouse(query, form);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async changeDeliveryProgram(_, {query, form }) {
      try {
        const response = await deliverySetApi.changeDeliveryProgram(query, form);
        return Promise.resolve(response.data);
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async changeProducer({dispatch}, {query, form }) {
      try {
        const response = await deliverySetApi.changeProducer(query, form);
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async deleteProducer(_, {query}) {
      try {
        await deliverySetApi.deleteProducer(query);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async splitCarcase(_, {query, form}) {
      try {
        await deliverySetApi.splitCaracases(query, form);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    },
    async updateSummaryAddition(_, {query, form}) {
      try {
        await deliverySetApi.updateSummaryAddition(query, form);
        return Promise.resolve();
      } catch(error) {
        return await Promise.reject(error);
      }
    }
  }
}
